import { DocFile } from 'src/app/models/docfile.model'

export const DOCFILE1: DocFile = new DocFile({
    idDocFile: '779d0842375073e8bc58b0bad5106027',
    order: 1,
    name: 'Igualdad de genero',
    url: 'http://cedoc.inmujeres.gob.mx/documentos_download/100803.pdf'
});